export default applet => {
  if (typeof applet.config_type !== "string")
    throw new Error("Use an applet object with config_type property")

  return applet.config_type === "static" ? "Applet" : "connection"
}
